import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import rootReducer from '../store/reducers'

const env = process.env.NODE_ENV
const base = process.env.REACT_APP_BASE

// Set the current language with the URL
export function setBaseName() {
  const path = window.location.pathname
  const langs = ['/en/', '/ca/', '/es/', '/pl/']
  let basename = ''
  let lang = langs.filter((i) => path.includes(i))[0] || ''
  if (env === 'production' && lang && base !== lang) {
    lang = lang.replace(/(\/)+/g, '')
    basename = `${lang}/`
  }

  return basename
}

export const history = createBrowserHistory({
  basename: `${base}/${setBaseName()}`,
})

export function configureStore(initialState) {
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const store = createStore(
    rootReducer(history),
    initialState,
    composeEnhancers(applyMiddleware(thunk, routerMiddleware(history)))
  )
  return store
}

export const store = configureStore()
